import { render, staticRenderFns } from "./LevelThreeTab.vue?vue&type=template&id=29c0d4e8"
import script from "./LevelThreeTab.vue?vue&type=script&lang=js"
export * from "./LevelThreeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports